import { useQuery } from "@tanstack/react-query";
import { jeopardyApi } from "../../jeopardy/api/jeopardy";

export const useFetchCriticalActions = (projectId: string | undefined) => {

    const { data, isLoading, isSuccess, isError, error } = useQuery({
        queryKey: ["critical-actions", projectId],
        queryFn: () => jeopardyApi.fetchJeopardy({ page: 1, limit: 5, projectId }),
    });

    return { criticalActionsData: isSuccess ? data?.data?.rows : [], isPending: isLoading, isError, error };

};